module.exports = __webpack_public_path__ + "static/media/Erp2.b4429888.png";